import Button from "@material-ui/core/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";
import { instance, instanceMultipart } from "Actions/AxiosInstance";
import uploadIcon from "Assets/newicons/action/upload/outline/upload-outline-16px.svg";
import DynamicForm from "Component/DynamicForm";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import { integerinputconverter } from "Component/DynamicForm/Fields/Integer";
import Thumbnail from "Component/Thumbnail/ThumbnailBig";
import { withSnackbar } from "notistack";
import React from "react";
import Select from "react-select";
import Dropzone from "react-dropzone";
import ReactPhoneInput from "react-phone-input-2";
import { connect } from "react-redux";
import { getFormattedImageLink } from "Utils";
import "./index.scss";
import CallOutNew from "Component/Headers/callOutNew";

const styles = () => ({
  drawerPaper: {
    width: "30%",
  },
});

class Addapplication extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pipelinestageid: "",
      isinvalidemailid: false,
      postdata: {
        name: null,
        mobilenumber: "",
        callingcode: null,
        emailid: null,
        city: null,

        requisitionjobid: null,
        expectedsalary: "",
        noticeperiod: "",
        profilepicpath: null,
        elementryskill: null,
        advanceskill: null,
        resumepath: null,
        coverletterpath: null,
        candidatecontact: [],
        candiatequestionfeedback: [],
        sourcetypeid: null,
        selectedsource: null,
        candidateexperience: [],
        candidateeducation: [],
        pipelinestageid: this.props.pipelinestageid || null,
      },

      jobTemplates: [],
      categorysourcelist: [],
      stageCategories: this.props.pipelinestagelist,
      expectedCompensation: "",
      pastCompensation: "",
      noticePeriodDays: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.configCandidateDetails = this.configCandidateDetails.bind(this);
    this.uploadDoc = this.uploadDoc.bind(this);
    this.getJobTemplate = this.getJobTemplate.bind(this);
    this.getCandidateSoruce = this.getCandidateSoruce.bind(this);
  }

  componentDidMount() {
    this.getJobTemplate();
    this.getCandidateSoruce();
    window.scrollTo(0, 0);
    this.setState({ isinvalidemailid: false });
  }

  validateEmail(value) {
    // const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    const mailformat =
      /^\w+([.-]?\w+)*([+]{0,1}\w+){0,1}@\w+([.-]?\w+)*(\.\w{2,15})+$/;

    if (value.match(mailformat)) {
      this.setState({ isinvalidemailid: false });
      return true;
    } else {
      this.setState({ isinvalidemailid: true });
      return false;
    }
  }

  getJobTemplate = () => {
    instance
      .get(
        `recruit/getrequisitionjoblist/null/${
          this.props.carddata
            ? this.props.carddata.displayvalue
            : this.props.tabpipelineid
        }`,
      )
      .then((result) => {
        const jobTemplates =
          result.data.result &&
          result.data.result.map((x) => ({
            displayname: x.designationname,
            displayvalue: x.requisitionjobid,
          }));
        this.setState({ jobTemplates });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  getCandidateSoruce = () => {
    instance
      .get(`recruit/getsourcetype`)
      .then((result) => {
        const categorysourcelist = result.data.result;
        const opt = [];
        const arrCategory = [];
        categorysourcelist.forEach((source) => {
          if (
            !arrCategory.some(
              (category) =>
                category.subcandidatesourcecategoryid ==
                source.subcandidatesourcecategoryid,
            )
          ) {
            arrCategory.push({
              subcandidatesourcecategoryid: source.subcandidatesourcecategoryid,
              categoryname: source.categoryname,
            });
          }
        });

        arrCategory.forEach((category) => {
          opt.push({
            label: category.categoryname,
            options: categorysourcelist.filter(
              (source) =>
                source.subcandidatesourcecategoryid ==
                category.subcandidatesourcecategoryid,
            ),
          });
        });

        this.setState({ categorysourcelist: opt });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  handleChange(name, value, indx = null) {
    const { postdata, selectedContactType } = this.state;

    if (indx == 1) {
      if (name == "contacttypeid") {
        selectedContactType[name] = value && value.displayvalue;
        selectedContactType.contacttype = value;
      } else {
        selectedContactType[name] = value;
      }

      this.setState({ selectedContactType });
    } else if (
      name == "jobtemplateid" ||
      name == "sourceid" ||
      name == "locationId"
    ) {
      this.setState({ [name]: value });
    } else if (name == "sourcetypeid") {
      postdata[name] = value.displayvalue;
      postdata.selectedsource = value;

      this.setState({ postdata });
    } else {
      postdata[name] = value;
      this.setState({
        postdata,
      });
    }
  }

  OnPhoneChange(field, value) {
    this.state.postdata.countryname = value.name;
    this.state.postdata.callingcode = value.dialCode;
    this.state.postdata.mobilenumber = field;
    field = field.replace(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g, "");
    const no = field.replace(value.dialCode, "");
    this.state.postdata.no = no.trim();

    const { postdata } = this.state;

    this.setState({ postdata });
  }

  onDeleteDoc(key) {
    const { postdata } = this.state;
    postdata[key] = null;
    this.setState({
      postdata,
    });
  }

  async uploadDoc(key, files) {
    const { postdata } = this.state;

    const formData = new FormData();
    formData.append("file", files[0]);

    instanceMultipart
      .post(
        `/drive/uploaddocument/${this.props.SubscriptionData.subscriptionid}/${this.props.SubscriptionData.employeeid}`,
        formData,
      )
      .then((resp) => {
        postdata[key] = resp.data.result[0].imagepath;

        this.setState({
          postdata,
        });
      });
  }

  configCandidateDetails() {
    const { postdata } = this.state;
    if (!postdata.requisitionjobid) {
      this.props.enqueueSnackbar("Please select job", {
        variant: "error",
      });
      return;
    } else if (!postdata.pipelinestageid) {
      this.props.enqueueSnackbar("Please select satge to add application", {
        variant: "error",
      });
      return;
    } else if (!postdata.name) {
      this.props.enqueueSnackbar("Please add name", {
        variant: "error",
      });
      return;
    } else if (!postdata.resumepath) {
      this.props.enqueueSnackbar("Please add resume", {
        variant: "error",
      });
      return;
    } else if (!postdata.mobilenumber) {
      this.props.enqueueSnackbar("Please add mobile number", {
        variant: "error",
      });
      return;
    } else if (!postdata.emailid) {
      this.props.enqueueSnackbar("Please add email", {
        variant: "error",
      });
      return;
    } else if (!postdata.city) {
      this.props.enqueueSnackbar("Please add city", {
        variant: "error",
      });
      return;
    } else if (!postdata.noticeperiod) {
      this.props.enqueueSnackbar("Please add notice period", {
        variant: "error",
      });
      return;
    } else if (!postdata.expectedsalary) {
      this.props.enqueueSnackbar("Please add expected salary", {
        variant: "error",
      });
      return;
    } else if (!postdata.advanceskill) {
      this.props.enqueueSnackbar("Please add advance skill", {
        variant: "error",
      });
      return;
    } else if (!postdata.elementryskill) {
      this.props.enqueueSnackbar("Please add elementry skill", {
        variant: "error",
      });
      return;
    }

    postdata.mobilenumber = postdata.no;

    if (this.state.isinvalidemailid) {
      this.props.enqueueSnackbar("Please add valid email id", {
        variant: "error",
      });
      // return;
    } else {
      instance
        .post("recruit/configcandidateapplication", postdata)
        .then((result) => {
          this.setState(
            {
              drawerOpen: false,
              createnew: false,
              postdata: [],
            },
            () => {
              this.props.CloseDrawer();
              this.props.getData(this.props.carddata);
            },
          );
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  render() {
    const { postdata } = this.state;
    return (
      <div className="padding-bottom-16">
        <DynamicForm
          fields={selectinputconverter({
            value: postdata.pipelinestageid,
            placeholder: "New",
            label: "Select stage to place",
            options: this.state.stageCategories || [],
          })}
          onChange={(value) => {
            this.handleChange("pipelinestageid", value);
          }}
        />

        <DynamicForm
          fields={selectinputconverter({
            value: postdata.requisitionjobid,
            placeholder: "Select job",
            label: "Job applied",
            options: this.state.jobTemplates,
          })}
          onChange={(selectedid) => {
            this.handleChange("requisitionjobid", selectedid);
          }}
        />

        <p className="inout-label">Upload profile picture</p>
        {postdata.profilepicpath == null ? (
          <Tooltip title="Click here to upload" placement="top">
            <Dropzone
              onDrop={(e) => this.uploadDoc("profilepicpath", e)}
              multiple={false}
              accept="image/*"
              maxSize={2000000}
              className="drag-drop"
            >
              <div
                className="cursor-pointer"
                style={{
                  width: 80,
                  border: "1px dashed #d9dadb",
                  padding: 16,
                  borderRadius: 4,
                  marginBottom: 16,
                  background: "#fff",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  <img
                    src={uploadIcon}
                    className="vertical-middle text-center display-block margin-bottom-8"
                    style={{ margin: "auto" }}
                  ></img>
                  <span className="extra-small-dark-secondary">
                    Click here to upload
                  </span>
                </div>
              </div>
            </Dropzone>
          </Tooltip>
        ) : (
          <Thumbnail
            key="key"
            onDelete={() => this.onDeleteDoc("profilepicpath")}
            onEdit={(file) => this.uploadDoc("profilepicpath", file)}
            filetypes="image/*"
            doc={{
              url: getFormattedImageLink(postdata.profilepicpath),
            }}
          />
        )}
         <p className="input-label" style={{ marginTop: 8 }}>
          Note: Upload attachment with max size 2 MB for
          optimum results. (Supports .gif, .jpeg, .png file
          types)
        </p>
        <DynamicForm
          fields={textinputconverter({
            value: postdata.name,
            label: "Candidate Name*",
            placeholder: "Enter name",
          })}
          onChange={(value) => {
            this.handleChange("name", value);
          }}
        />

        <DynamicForm
          fields={textinputconverter({
            value: postdata.emailid,
            label: "Candidate email*",
            placeholder: "Enter email id",
          })}
          onChange={(value) => {
            this.handleChange("emailid", value);
          }}
          onBlur={(e) => this.validateEmail(e.target.value)}
        />

        {this.state.isinvalidemailid && (
          <p className="small-red-dark margin-bottom-8">
            Please enter valid email address!
          </p>
        )}

        <p className="input-label">Candidate phone*</p>
        <div className="margin-bottom-16">
          <ReactPhoneInput
            defaultCountry={"in"}
            countryCodeEditable={false}
            className="form-control"
            value={postdata.mobilenumber}
            // onChange={(value) => this.handleChange("mobilenumber", value)}
            onChange={this.OnPhoneChange.bind(this)}
            InputProps={{ maxLength: 15, minLength: 5 }}
          />
        </div>

        <div>
          <DynamicForm
            fields={textinputconverter({
              value: postdata.city,
              label: "Candidate location*",
              placeholder: "Enter city name",
            })}
            onChange={(value) => {
              this.handleChange("city", value);
            }}
          />
        </div>

        <p className="input-label">Select source</p>
        <div className="margin-bottom-16">
          <Select
            className="selectsearch inlindClass width100"
            onChange={(selectedItem) =>
              this.handleChange("sourcetypeid", selectedItem)
            }
            options={this.state.categorysourcelist}
            getOptionLabel={(option) => option.displayname}
            getOptionValue={(option) => option.displayvalue}
            value={this.state.postdata.selectedsource}
            placeholder="Select Source"
            isClearable={true}
          />
        </div>

        <DynamicForm
          fields={textinputconverter({
            value: postdata.advanceskill,
            label: "Advance skill*",
            placeholder: "Enter skill",
          })}
          onChange={(value) => {
            this.handleChange("advanceskill", value);
          }}
        />

        <DynamicForm
          fields={textinputconverter({
            value: postdata.elementryskill,
            label: "Elementry skill*",
            placeholder: "Enter skill",
            autoFocus: false,
          })}
          onChange={(value) => {
            this.handleChange("elementryskill", value);
          }}
        />

        <DynamicForm
          fields={integerinputconverter({
            value: postdata.noticeperiod,
            label: "Notice period*",
            placeholder: "Enter notice period",
          })}
          onChange={(value) => {
            this.handleChange("noticeperiod", value);
          }}
        />

        <DynamicForm
          fields={integerinputconverter({
            value: postdata.expectedsalary,
            label: "Expected salary*",
            placeholder: "Enter salary",
          })}
          onChange={(value) => {
            this.handleChange("expectedsalary", value);
          }}
        />

        <p className="input-label">Upload resume*</p>

        <div>
          {postdata.resumepath == null ? (
            <Tooltip title="Click here to upload" placement="top">
              <Dropzone
                onDrop={(e) => this.uploadDoc("resumepath", e)}
                multiple={false}
                accept="application/pdf,application/msword"
                maxSize={2000000}
                className="drag-drop"
              >
                <div
                  className="cursor-pointer"
                  style={{
                    width: "92%",
                    border: "1px dashed #d9dadb",
                    padding: 16,
                    borderRadius: 4,
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      textAlign: "center",
                    }}
                  >
                    <img
                      src={uploadIcon}
                      className="vertical-middle text-center display-block margin-bottom-8"
                      style={{ margin: "auto" }}
                    ></img>
                    <span className="extra-small-dark-secondary">
                      Click here to upload
                    </span>
                  </div>
                </div>
              </Dropzone>
            </Tooltip>
          ) : (
            <Thumbnail
              key="key"
              onDelete={() => this.onDeleteDoc("resumepath")}
              onEdit={(file) => this.uploadDoc("resumepath", file)}
              filetypes="image/*"
              doc={{ url: getFormattedImageLink(postdata.resumepath) }}
            />
          )}
        </div>

        <div className="margin-top-8">
        <p className="input-label">
          Note:<br></br>
            Supported files: .pdf and msword<br></br>
            Max size: 2MB
        </p>
          {/* <CallOutNew
            classnames="bg-light-blue width100"
            header="Note: Supported file types are pdf and word file."
            emoji="📌"
            textcolor="#1e8ced"
          /> */}
        </div>

        <p className="input-label margin-top-16">Upload cover letter</p>
        <div>
          {postdata.coverletterpath == null ? (
            <Tooltip title="Click here to upload" placement="top">
              <Dropzone
                onDrop={(e) => this.uploadDoc("coverletterpath", e)}
                multiple={false}
                accept="application/pdf,application/msword"
                maxSize={2000000}
                className="drag-drop"
              >
                <div
                  className="cursor-pointer"
                  style={{
                    width: "92%",
                    border: "1px dashed #d9dadb",
                    padding: 16,
                    borderRadius: 4,
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      textAlign: "center",
                    }}
                  >
                    <img
                      src={uploadIcon}
                      className="vertical-middle text-center display-block margin-bottom-8"
                      style={{ margin: "auto" }}
                    ></img>
                    <span className="extra-small-dark-secondary">
                      Click here to upload
                    </span>
                  </div>
                </div>
              </Dropzone>
            </Tooltip>
          ) : (
            <Thumbnail
              key="key"
              onDelete={() => this.onDeleteDoc("coverletterpath")}
              onEdit={(file) => this.uploadDoc("coverletterpath", file)}
              filetypes="image/*"
              doc={{ url: getFormattedImageLink(postdata.coverletterpath) }}
            />
          )}
        </div>

        <div className="margin-top-8">
        <p className="input-label">
          Note:<br></br>
            Supported files: .pdf and msword<br></br>
            Max size: 2MB
        </p>
          {/* <CallOutNew
            classnames="bg-light-blue width100"
            header="Note: Supported file types are pdf and word file."
            emoji="📌"
            textcolor="#1e8ced"
          /> */}
        </div>

        <div>
          <Button
            variant="contained"
            className="btn btn-primary-lg-blue margin-right-16 margin-bottom-16 margin-top-16"
            color="primary"
            onClick={this.configCandidateDetails}
          >
            Add Candidate
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  SaveInProgressReducer: state.SaveInProgressReducer,
  SubscriptionData: state.SubscriptionInfo.SubscriptionData,
  login: state.AuthenticationAction.login,
});

export default connect(mapStateToProps)(
  withStyles(styles, { withTheme: true })(withSnackbar(Addapplication)),
);
